// Centralized Canadian/non-Canadian carrier display logic.
// All components use these helpers instead of inline conditionals.

export function getAttLabel(isCanadian: boolean): string {
  return isCanadian ? "Rogers/Bell" : "AT&T";
}

export function getAttLogo(
  isCanadian: boolean,
  variant: "dark" | "light" = "dark"
): string {
  const bg = variant === "dark" ? "DarkBackground" : "LightBackground";
  return isCanadian
    ? `/images/carriers_logo/RogersBell-${bg}.png`
    : `/images/carriers_logo/ATT-${bg}.png`;
}

export const CARRIER_LOGOS: Record<string, string> = {
  Verizon: "/images/carriers_logo/verizon.png",
  TMobile: "/images/carriers_logo/TMobile.png",
};

export function getCarrierLogo(
  carrier: string,
  isCanadian: boolean
): string {
  if (carrier === "ATT") return getAttLogo(isCanadian);
  return CARRIER_LOGOS[carrier] ?? "";
}

/** Plain logo paths (no background variant) — matches MVC screenshot gallery logos. */
export function getGalleryLogo(
  carrier: string,
  isCanadian: boolean
): string {
  if (carrier === "ATT" || carrier === "AT&T") {
    return isCanadian
      ? "/images/carriers_logo/RogersBell.png"
      : "/images/carriers_logo/ATT.png";
  }
  if (carrier === "Verizon") return "/images/carriers_logo/verizon.png";
  if (carrier === "TMobile") return "/images/carriers_logo/TMobile.png";
  return "";
}
